import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, retry } from 'rxjs';
import { MainService } from 'src/app/app.service';
import { McpToolUsageResponse } from '../interfaces/mcp-tool-usage';

export const DOCUMENTA_AI_TOOL_NAME = 'confluence-create-requirement-doc';

export interface DocumentaAiServerFilters {
  userId?: string;
  fromTimestamp?: string;
  toTimestamp?: string;
}

@Injectable({
  providedIn: 'root',
})
export class DocumentaAiService {
  constructor(
    private _http: HttpClient,
    private mainService: MainService,
  ) {}

  getUsage(
    tool: string = DOCUMENTA_AI_TOOL_NAME,
    page: number = 1,
    limit: number = 100,
    filters: DocumentaAiServerFilters = {},
  ): Observable<McpToolUsageResponse> {
    const params: Record<string, string> = { tool, page: String(page), limit: String(limit) };
    if (filters.userId) params['userId'] = filters.userId;
    if (filters.fromTimestamp) params['fromTimestamp'] = filters.fromTimestamp;
    if (filters.toTimestamp) params['toTimestamp'] = filters.toTimestamp;

    return this._http
      .get<McpToolUsageResponse>('/api/v2/mcp/usage', {
        ...this.mainService.httpOptions,
        params,
      })
      .pipe(
        retry(2),
        map((response) => response),
        catchError(this.mainService.handleError),
      );
  }
}
